import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { DriftStatusBesked } from 'src/app/api/models';
import { OperatingStatusService } from '../../services/operating-status/operating-status.service';

@Component({
  selector: 'bom-operating-status',
  templateUrl: './operating-status.component.html',
  styleUrls: ['./operating-status.component.scss'],
})
export class OperatingStatusComponent implements OnInit {
  driftStatusBeskeder$: Observable<DriftStatusBesked[]>;

  constructor(private operatingStatusService: OperatingStatusService) {}

  ngOnInit(): void {
    this.driftStatusBeskeder$ = this.operatingStatusService.driftStatusBeskeder$;
  }

  close(driftStatusBesked: DriftStatusBesked) {
    this.operatingStatusService.hide(driftStatusBesked);
  }
}
